import $ from 'jquery';

/**
 * Add "u-margin-top" to any `.wysiwyg p` elements that only contain `a.button`
 * elements (ignoring <br> and whitespace text).
 */
$('.wysiwyg p').each(function () {
  const $this = $(this);
  const $clone = $this.clone();
  // Remove non-<a.button> or <br> children ("whitelisted")
  $clone.children().filter('a.button, br').remove();
  // If the element contains no other elements, and no non-whitespace text.
  if ($clone.children().length === 0 && $clone.text().trim() === '') {
    $this.addClass('u-margin-top');
  }
});
